import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { useAuth } from 'react-oidc-context';

const SignOut: React.FC = () => {
  const navigate = useNavigate();
  const auth = useAuth();

  // If user is still authenticated, sign them out
  useEffect(() => {
    if (auth.isAuthenticated) {
      auth.signoutRedirect({
        post_logout_redirect_uri: window.location.origin + '/signout',
        extraQueryParams: {
          client_id: process.env.REACT_APP_CLIENT_ID || '',
          logout_uri: window.location.origin + '/signout'
        },
      }).catch(err => {
        console.error('Error during sign out:', err);
      });
    }
  }, [auth]);

  const handleSignIn = () => {
    navigate('/'); // This will trigger the auth flow via AuthRoute
  };

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <ExitToAppIcon color="action" sx={{ fontSize: 60, mb: 2 }} />
          <Typography component="h1" variant="h5" gutterBottom>
            You've been signed out
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 3 }}>
            Thank you for using MentoringFusion. You have been successfully signed out of your account.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSignIn}
            startIcon={<ExitToAppIcon />}
            sx={{ mt: 2 }}
          >
            Sign In Again
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default SignOut;
